module.exports = __webpack_public_path__ + "static/power-593f304ea497d3119c738b890c920a9c.jpg";